import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Plus, RefreshCw } from "lucide-react";

export function PageHeader({ title, subtitle, actions, testid = "page-header" }) {
  return (
    <div className="flex items-end justify-between flex-wrap gap-4 mb-6" data-testid={testid}>
      <div>
        <div className="text-[10px] uppercase tracking-widest text-muted-foreground font-semibold">Kabir Infra ERP</div>
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight mt-1">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function DataTable({ columns, data, empty = "No records yet", onRow, testid = "data-table" }) {
  return (
    <div className="border border-border rounded-md overflow-hidden bg-card" data-testid={testid}>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-secondary/50">
            <tr className="text-left">
              {columns.map((c) => (
                <th key={c.key} className="px-4 py-3 text-[10px] font-semibold uppercase tracking-widest text-muted-foreground">
                  {c.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length === 0 && (
              <tr><td colSpan={columns.length} className="text-center py-16 text-muted-foreground text-sm">{empty}</td></tr>
            )}
            {data.map((row, i) => (
              <tr
                key={row.id || i}
                onClick={() => onRow?.(row)}
                className={`table-row border-t border-border ${onRow ? "cursor-pointer" : ""}`}
                data-testid={`row-${i}`}
              >
                {columns.map((c) => (
                  <td key={c.key} className="px-4 py-3">{c.render ? c.render(row) : row[c.key]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function PrimaryButton({ children, ...props }) {
  return (
    <Button {...props} className={`bg-kabir hover:bg-[#DCA000] text-zinc-900 font-semibold active:scale-[0.98] transition-all ${props.className || ""}`}>
      {children}
    </Button>
  );
}
